<section class="service-bg min-h-screen md:pr-12 px-4">
  <!-- header content -->
  <div class="service-header">
    <h2>أولاً أجرى:</h2>
  </div>

  <div class="service-content">
    <p class="pb-8">هى منصة متخصصه فى :</p>

    <p>
      تسويق وعرض الفرص الزراعية ، للراغبين في الشراء او الامتلاك او انشاء المشروعات الزراعية ،
      <br />والتعرف على الشركات المتخصصة المتواجدة في سوق الاستثمار الزراعي.
    </p>

    <p>
      وفق أسس علمية واستثمارية وقانونية واضحة ، وبأحدث الأساليب والتقنيات، مع التركيز على الاستدامة
      <br />، وتعظيم العائد الانتاجي ودعم الأمن الغذائي في جمهورية مصر العربية.
    </p>

    <p>
      نؤمن في أولا : بأن القطاع الزراعي هو القلب النابض للاقتصاد المصري، وأن إتاحة فرص <br />التعاقد
      فيه لشرائح واسعة من الجمهور هو الطريق الأمثل لتحقيق<br />
      نمو مستدام يستفيد منه الجميع. <br />
      وفق رؤية الدولة ٢٠٣٠ لزيادة الانتاج والرقعة الزراعية في مصر.
    </p>
  </div>

  <!-- button -->
  <div class="flex mt-10 cursor-pointer justify-center md:justify-start">
    <button
      routerLink="/about"
      class="text-(--color-main) bg-(--color-secondary) px-12 h-12 rounded-3xl font-bold inline-flex items-center gap-2 cursor-pointer border-2 border-(--color-main) hover:bg-(--color-main-20) hover:text-(--color-secondary) transition-all duration-300"
    >
      اعرف المزيد عنا
    </button>
  </div>
</section>
